import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
  ChartJS.register(ArcElement, Tooltip)

const HROverviewChart = ({ data }) => {

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    }

  return (
    <>
      {data ? (
        <div className='flex w-full h-full gap-2 '>
          <div className='md:w-[50%] w-[50%] relative'>
            {data.data && <Doughnut data={data.data} options={chartOptions} />}
            <div className='absolute w-full top-[57%] left-0 text-center -mt-[20px] md:-mt-6 line'>
              <span className='text-[13px] font-extrabold'>{data.total}</span>
            </div>
          </div>
          <div className='mt-4 flex flex-col gap-2'>
            {data.legends.map((item, index) => (
              <div key={index} className='flex flex-row items-center'>
                <div
                  className={`w-[8px] h-[8px] rounded-[8px] ${item.color}`}
                ></div>
                <span className='pl-1  text-sm'> {item.title}</span>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default HROverviewChart
